function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
var _excluded = ["component", "measure", "small", "large", "size", "align", "color", "weight", "transform"],
  _excluded2 = ["theme"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { copyColor, copyFontFamily, copyFontSize, copyLineHeight, copyFontSizeSmall, copyFontSizeLarge } from "@nib-components/theme";
import { color as getColor, validColorValues, map } from "@nib/layout";
import { validAlignValues, validComponentValues, validWeightValues } from "./utils";
export var validSizeValues = ["small", "medium", "large"];
var BaseCopy = function BaseCopy(props) {
  /* eslint-disable @typescript-eslint/no-unused-vars */var _props$component = props.component,
    Component = _props$component === void 0 ? "p" : _props$component,
    measure = props.measure,
    small = props.small,
    large = props.large,
    size = props.size,
    align = props.align,
    color = props.color,
    weight = props.weight,
    transform = props.transform,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Component, _extends({
    "data-mesh-component": "COPY"
  }, otherProps));
};
var isNamedColor = function isNamedColor(color) {
  if (!color) return false;
  if (validColorValues.includes(color)) {
    return true;
  }
  return false;
};
var setColor = function setColor(props) {
  if (isNamedColor(props.color)) {
    return getColor(props);
  }
  if (props.color !== "inherit") {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), props.color || copyColor);
  }
  return "color: inherit";
};
var Copy = styled(function (_ref) {
  var theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded2);
  return /*#__PURE__*/React.createElement(BaseCopy, rest);
}).attrs(function (props) {
  return _objectSpread({
    measure: true,
    align: "left",
    color: "inherit",
    small: false,
    large: false,
    weight: "normal"
  }, props);
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0;\n\n  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion\n  ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  \n  ", "\n"])), function (props) {
  return setColor(_objectSpread(_objectSpread({}, props), {}, {
    color: props.color
  }));
}, copyFontFamily, copyFontSize, copyLineHeight, function (props) {
  return props.transform && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      text-transform: ", ";\n    "])), props.transform);
}, function (props) {
  return props.measure && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      max-width: 32em;\n    "])));
}, function (_ref2) {
  var align = _ref2.align,
    measure = _ref2.measure;
  return map(align, function (val) {
    if (measure) {
      if (val === "left") return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            text-align: ", ";\n            margin-right: auto;\n            margin-left: 0;\n          "])), val);
      if (val === "center") return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            text-align: ", ";\n            margin-left: auto;\n            margin-right: auto;\n          "])), val);
      if (val === "right") return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            text-align: ", ";\n            margin-left: auto;\n            margin-right: 0;\n          "])), val);
    } else if (align) {
      return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          text-align: ", ";\n        "])), val);
    }
    return "";
  });
}, function (props) {
  return props.small && css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      font-size: ", ";\n    "])), copyFontSizeSmall);
}, function (props) {
  return props.large && css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      font-size: ", ";\n    "])), copyFontSizeLarge);
}, function (props) {
  return props.size && !props.small && !props.large && map(props.size, function (val) {
    if (val === "small") {
      return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n          font-size: ", ";\n        "])), copyFontSizeSmall);
    } else if (val === "large") {
      return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n          font-size: ", ";\n        "])), copyFontSizeLarge);
    } else {
      return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n          font-size: ", ";\n        "])), copyFontSize);
    }
  });
});
Copy.displayName = "Copy";
export default Copy;
export var Italic = styled(Copy).attrs({
  component: "em",
  "data-mesh-component": "ITALIC"
})(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-style: italic;\n\n  ", " > & {\n    font-size: inherit;\n  }\n"])), Copy);
Italic.displayName = "Italic";
export var Bold = styled(Copy).attrs(function (props) {
  return _objectSpread(_objectSpread({
    component: "strong",
    "data-mesh-component": "BOLD"
  }, props), {}, {
    weight: "bold"
  });
})(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n\n  ", " > & {\n    font-size: inherit;\n  }\n"])), function (props) {
  return props.weight;
}, Copy);
Bold.displayName = "Bold";
Bold.propTypes = {
  weight: PropTypes.oneOfType([PropTypes.oneOf(["bold"]), PropTypes.number])
};